module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.renderData && _vm.renderData.length && _vm.renderData.length > 1) ? _c('div', {
    staticClass: "FullWidthBannercard d-flex flex-column",
    class: {
      'filter-landing-widget-wrapper': _vm.isFilterLanding,
      'shop-the-look': _vm.callerComp === 'shopTheLook',
      'supima-landing': _vm.callerComp === 'supimaLandingPage',
      'activewear-landing': _vm.callerComp === 'activeWearLandingPage' || _vm.callerComp === 'winterWearLandingPage'
    },
    style: ([_vm.bannerStyle])
  }, [(_vm.renderName || _vm.getDescription) ? _c('div', {
    staticClass: "FullWidthBannercard__title-cont"
  }, [_c('div', {
    staticClass: "title_container"
  }, [(_vm.isFilterLanding) ? _c('div', [(_vm.renderName) ? _c('div', {
    staticClass: "category-title-container"
  }, [_c('div', {
    staticClass: "mobile-lines-container"
  }, _vm._l((_vm.deviceWidth), function(e, i) {
    return _c('div', {
      key: i,
      staticClass: "rotate-line"
    }, [_vm._v("|")])
  })), _vm._v(" "), _c('h3', {
    staticClass: "filter-landing-title"
  }, [_vm._v(_vm._s(_vm.renderName))])]) : _vm._e()]) : (_vm.renderName) ? _c('h3', {
    staticClass: "title",
    class: !_vm.isDesktop ? 'pl-4' : ''
  }, [_vm._v(_vm._s(_vm.renderName))]) : _vm._e()]), _vm._v(" "), (_vm.getDescription) ? _c('p', {
    staticClass: "descrition"
  }, [_vm._v(_vm._s(_vm.getDescription))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "headtop prelative top-banner"
  }, [_c('carousel', {
    ref: "my-carousel",
    class: _vm.isDesktop ? 'bannerview' : 'mobileBannerView',
    attrs: {
      "navigationEnabled": _vm.isDesktop,
      "paginationEnabled": _vm.isPaginationProp ? _vm.showPagination : _vm.callerComp !== 'shopTheLook' && !_vm.isDesktop,
      "navigationNextLabel": " ",
      "navigationPrevLabel": " ",
      "autoplay": false,
      "loop": _vm.isFilterLanding ? true : '',
      "autoplayTimeout": _vm.isFilterLanding ? 4000 : 2500,
      "speed": 500,
      "perPage": 1,
      "paginationPadding": 1,
      "paginationSize": 6,
      "paginationPosition": 'bottom',
      "paginationActiveColor": _vm.paginationActiveColor && _vm.paginationActiveColor,
      "paginationColor": _vm.paginationColor ? _vm.paginationColor : '#979a9f'
    }
  }, _vm._l((_vm.renderData.slice(0, _vm.renderData.length - 1)), function(bimg, index) {
    return _c('slide', {
      key: index
    }, [(bimg.is_video && (bimg.video_url || bimg.web_video_url)) ? _c('div', {
      staticClass: "w-full"
    }, [_c('VideoPlayer', {
      attrs: {
        "src": _vm.isDesktop ? bimg.web_video_url : bimg.video_url,
        "poster": _vm.isDesktop ? bimg.image_web : bimg.image,
        "playVideo": true
      }
    })], 1) : _c('div', [(bimg.navigation_link || _vm.isHTTPUrl(bimg.url)) ? _c('a', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.callerComp === 'homePage' ? _vm.getBannerImpressionData(bimg, index) : null),
        expression: "callerComp === 'homePage' ? getBannerImpressionData(bimg, index) : null"
      }],
      staticClass: "d-inline-block w-100",
      attrs: {
        "href": bimg.navigation_link || bimg.url
      }
    }, [_c('router-link', {
      attrs: {
        "to": bimg.left_url || ''
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClickEventsHandler(Object.assign({}, bimg,
            {side: 'left'}), index)
        }
      }
    }, [_c('img', {
      staticClass: "img-auto",
      class: {
        customFade: _vm.callerComp === 'homePage'
      },
      attrs: {
        "data-url": _vm.callerComp === 'homePage' ? _vm.getImageSrc(bimg) : '',
        "data-src": _vm.callerComp === 'homePage' ? '' : _vm.getImageSrc(bimg),
        "alt": bimg.navigation_link || bimg.alt || 'Banner',
        "width": "1500",
        "height": "385"
      },
      on: {
        "click": function($event) {
          _vm.onClickEventsHandler(bimg, index)
        }
      }
    })])], 1) : _c('router-link', {
      directives: [{
        name: "bannerImageLoad",
        rawName: "v-bannerImageLoad",
        value: (_vm.callerComp === 'homePage' ? _vm.getBannerImpressionData(bimg, index) : null),
        expression: "callerComp === 'homePage' ? getBannerImpressionData(bimg, index) : null"
      }],
      staticClass: "d-inline-block w-100 my-1",
      attrs: {
        "to": {
          path: _vm.getImageUrl(bimg) || '',
          hash: _vm.getImageHashUrl(bimg) || ''
        }
      }
    }, [_c('img', {
      staticClass: "img-auto",
      class: {
        customFade: _vm.callerComp === 'homePage'
      },
      attrs: {
        "data-url": _vm.callerComp === 'homePage' ? _vm.getImageSrc(bimg) : '',
        "data-src": _vm.callerComp === 'homePage' ? '' : _vm.getImageSrc(bimg),
        "alt": bimg.url || bimg.alt || 'Banner',
        "width": "1500",
        "height": "385"
      },
      on: {
        "click": function($event) {
          _vm.handleBannerClick(bimg, index)
        }
      }
    })]), _vm._v(" "), (bimg.is_banner_split) ? _c('div', {
      staticClass: "pabsolute w-full banner-btns-wrapper d-flex justify-content-center"
    }, [_c('router-link', {
      attrs: {
        "to": bimg.left_url || ''
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClickEventsHandler(Object.assign({}, bimg,
            {side: 'left'}), index)
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-danger text-uppercase left-btn"
    }, [_vm._v(_vm._s(_vm.isDesktop ? 'men' : 'shop men'))])]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": bimg.right_url || ''
      },
      nativeOn: {
        "click": function($event) {
          _vm.onClickEventsHandler(Object.assign({}, bimg,
            {side: 'right'}), index)
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-danger text-uppercase right-btn"
    }, [_vm._v(_vm._s(_vm.isDesktop ? 'women' : 'shop women'))])])], 1) : _vm._e()], 1)])
  }))], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c0c6090"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/FullWidthCarouselBanner.vue
// module id = 1088
// module chunks = 3 16 23 28 30 31 44 62